import { useEffect, useState } from 'react';
import { ImportProgressBar } from './ImportProgressBar';

interface ImportLoadingViewProps {
  progress?: number; // 0-100、指定がある場合はその値を使用
}

/**
 * データ取り込み中の表示
 */
export function ImportLoadingView({ progress: externalProgress }: ImportLoadingViewProps) {
  const [internalProgress, setInternalProgress] = useState(0);

  useEffect(() => {
    // propsでprogressが指定されている場合は自動進行しない
    if (externalProgress !== undefined) {
      return;
    }

    // 100msごとに進捗を更新（0%から90%まで約9秒）
    const interval = setInterval(() => {
      setInternalProgress((prev) => {
        // 90%を上限とする（実際の処理完了は外部から通知される想定）
        if (prev >= 90) {
          return prev;
        }
        // 1%ずつ増加
        return prev + 1;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [externalProgress]);

  const displayProgress = externalProgress ?? internalProgress;

  return (
    <div className="flex h-[640px] flex-col items-center justify-center gap-6 rounded-sm bg-white p-6 shadow-layer1">
      <p className="text-center text-body-lg leading-relaxed">
        データを取り込んでいます。
        <br />
        ページを閉じずにしばらくお待ちください。
      </p>
      <ImportProgressBar progress={displayProgress} />
    </div>
  );
}
